import addDays from 'date-fns/addDays';
import addMonths from 'date-fns/addMonths';
import subMonths from 'date-fns/subMonths';
import startOfMonth from 'date-fns/startOfMonth';
import endOfMonth from 'date-fns/endOfMonth';
import startOfQuarter from 'date-fns/startOfQuarter';
import endOfQuarter from 'date-fns/endOfQuarter';
import subQuarters from 'date-fns/subQuarters';
import startOfYear from 'date-fns/startOfYear';
import endOfYear from 'date-fns/endOfYear';
import subYears from 'date-fns/subYears';
import { dateRangeObject } from '../consts/dateRange';
import { DATE_FORMAT } from '@shared/consts/constants';
import { format } from 'date-fns';

interface DateRange {
  from: string;
  to: string;
}

export const calculateDateRange = (optionValue: string): DateRange | null => {
  const today = new Date();
  let from: Date | null = null;
  let to: Date | null = null;

  switch (optionValue) {
    case dateRangeObject.last7Days.value:
      from = addDays(today, -7);
      to = today;
      break;
    case dateRangeObject.last2Weeks.value:
      from = addDays(today, -14);
      to = today;
      break;
    case dateRangeObject.lastMonth.value:
      from = addMonths(today, -1);
      to = today;
      break;
    case dateRangeObject.lastQuarter.value:
      from = startOfQuarter(subQuarters(today, 1));
      to = endOfQuarter(subQuarters(today, 1));
      break;
    case dateRangeObject.lastYear.value:
      from = startOfYear(subYears(today, 1));
      to = endOfYear(subYears(today, 1));
      break;
    case dateRangeObject.currentQuarter.value:
      from = startOfQuarter(today);
      to = today;
      break;
    case dateRangeObject.currentYear.value:
      from = startOfYear(today);
      to = today;
      break;
    case dateRangeObject.upcoming.value:
      from = today;
      to = addDays(today, 365);
      break;
    case dateRangeObject.thisMonth.value:
      from = startOfMonth(today);
      to = endOfMonth(today);
      break;
    case dateRangeObject.previousMonth.value:
      from = startOfMonth(subMonths(today, 1));
      to = endOfMonth(subMonths(today, 1));
      break;
    case dateRangeObject.thisQuarter.value:
      from = startOfQuarter(today);
      to = endOfQuarter(today);
      break;
    case dateRangeObject.thisYear.value:
      from = startOfYear(today);
      to = endOfYear(today);
      break;
  }

  if (from && to) {
    return {
      from: format(from, DATE_FORMAT),
      to: format(to, DATE_FORMAT),
    };
  }
  return null;
};

export const matchesDateRange = (from: string | null, to: string | null, optionValue: string): boolean => {
  if (!from || !to) return false;
  const calculated = calculateDateRange(optionValue);
  if (!calculated) return false;
  return calculated.from === from && calculated.to === to;
};
